import $ from 'jquery';

class TableTab {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.#init.bind(this));
  }

  #init() {
    TableTab.hideForms();
    const select = $('#table_selected').on('change', TableTab.handleChange.bind(this));
    // eslint-disable-next-line no-unused-vars
    const form = $('.opentable-form').on('submit', TableTab.handleSubmit.bind(this));
    const selectDefault = $('#table_selected option:selected') ?? $('#table_selected option:first-child');

    if (select.val()) {
      TableTab.showFrom(select.val());
    }

    if (selectDefault) {
      window.setTimeout(() => {
        TableTab.handleDefault(selectDefault.val());
      });
    }
  }

  static handleDefault(id) {
    TableTab.hideForms();
    TableTab.showFrom(id);
  }

  static handleChange(event) {
    TableTab.hideForms();
    TableTab.showFrom(event.target.value);
  }

  static handleSubmit(event) {
    const form = $(event.target);
    const date = form.find('.table-reservation__date').val();
    const time = form.find('.table-reservation__time').val();

    if (date && time) {
      form.find('.table-reservation__date-time').val(`${date}T${time}`);
    }

    return true;
  }

  static hideForms() {
    $('.table-form').hide();
  }

  static showFrom(formId) {
    const form = $(`#table-${formId}`);

    if (form.length) {
      form.show();
    }
  }
}

export default TableTab;
